import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getSuivi = async () => {
    return userRequest.get(`${DOMAIN}/api/suivi`);
  };

export const getSuiviOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/suivi/one?id_suivi=${id}`);
  };

export const getTrackingAllOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/suivi/tracking_all_one?id_tache=${id}`);
  };

export const getSuiviTacheUne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/suivi/suiviTacheUne?id_suivi=${id}`);
  };

export const getSuiviTacheOne = async (id, role) => {
    return userRequest.get(`${DOMAIN}/api/suivi/suiviTacheOne?id_user=${id}&role=${role}`);
  };

export const getSuiviTacheOneV = async (id) => {
    return userRequest.get(`${DOMAIN}/api/suivi/suiviTacheOneV?id_tache=${id}`);
  };

export const postSuivi = async (data) => {
  return userRequest.post(`${DOMAIN}/api/suivi`, data);
};

export const postSuiviTache = async (data) => {
return userRequest.post(`${DOMAIN}/api/suivi/suiviTache`, data);
};

export const estSupprimeSuivi = async (id) => {
  return userRequest.put(`${DOMAIN}/api/suivi/est_supprime?id=${id}`,);
};


export const deleteSuivi = async (id) => {
    return userRequest.delete(`${DOMAIN}/api/suivi/${id}`,);
  };

export const getDocgeneral = async (data) => {
    return userRequest.get(`${DOMAIN}/api/suivi/doc`, data);
  };

export const postDocGeneral = async (data) => {
    return userRequest.post(`${DOMAIN}/api/suivi/doc`, data,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  };